<template>
    <div>
        <app-hero />
        <app-features />
        <app-more />
        <app-footer-cta />
    </div>
</template>
<script>
import AppHero from '@/components/AppHero';
import AppFeatures from '@/components/AppFeatures';
import AppMore from '@/components/AppMore';
import AppFooterCta from '@/components/AppFooterCta';

export default {
    name: 'app-landing',
    components: { AppHero, AppFeatures, AppMore, AppFooterCta },
};
</script>
